var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsInactiveSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_394_191709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53843 23.0811C3.57238 24.8755 5.86533 25.4921 7.65982 24.4581C7.66105 24.4574 7.66222 24.4567 7.66345 24.456L8.21968 24.1347C9.26968 25.0331 10.4766 25.7298 11.7797 26.1897V26.8311C11.7797 28.9021 13.4586 30.5811 15.5297 30.5811C17.6007 30.5811 19.2797 28.9021 19.2797 26.8311V26.1898C20.5829 25.7291 21.7899 25.0316 22.8396 24.1323L23.3984 24.4548C25.1933 25.4903 27.4879 24.8747 28.5234 23.0798C29.5589 21.2849 28.9434 18.9903 27.1484 17.9547L26.5934 17.6348C26.8432 16.2753 26.8432 14.8817 26.5934 13.5222L27.1484 13.2023C28.9433 12.1667 29.5589 9.87221 28.5234 8.07725C27.4879 6.28234 25.1934 5.6667 23.3984 6.70223L22.8422 7.0235C21.7911 6.12625 20.5834 5.43086 19.2797 4.9723V4.33105C19.2797 2.26 17.6007 0.581055 15.5297 0.581055C13.4586 0.581055 11.7797 2.26 11.7797 4.33105V4.9723C10.4764 5.43303 9.26945 6.13053 8.21968 7.02982L7.66093 6.70609C5.86597 5.67051 3.57144 6.28615 2.53591 8.08105C1.50039 9.87596 2.11597 12.1705 3.91093 13.2061L4.46593 13.5261C4.21609 14.8855 4.21609 16.2791 4.46593 17.6386L3.91093 17.9586C2.12095 18.9968 1.50736 21.2869 2.53843 23.0811ZM15.5297 10.5811C18.2911 10.5811 20.5296 12.8196 20.5296 15.5811C20.5296 18.3425 18.2911 20.581 15.5297 20.581C12.7683 20.581 10.5297 18.3425 10.5297 15.5811C10.5297 12.8196 12.7683 10.5811 15.5297 10.5811Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_191709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.529297 0.581055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInactiveSm);
export default __webpack_public_path__ + "static/media/settings-inactive-sm.7befda4bcefff2303d53f7fa299d6392.svg";
export { ForwardRef as ReactComponent };